import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSettings } from '../contexts/SettingsContext';

const ROUTE_TITLES = [
  { pattern: /^\/$/, title: 'Beranda' },
  { pattern: /^\/schedule$/, title: 'Jadwal Pertandingan' },
  { pattern: /^\/prediction\/.+/, title: 'Tebak Skor' },
  { pattern: /^\/check-ticket$/, title: 'Cek Tiket' },
  { pattern: /^\/leaderboard$/, title: 'Leaderboard' },
  { pattern: /^\/winners$/, title: 'Pemenang' },
  { pattern: /^\/partners$/, title: 'Partner Resmi' },
  { pattern: /^\/terms$/, title: 'Syarat & Ketentuan' },
  { pattern: /^\/admin$/, title: 'Login Admin' },
  { pattern: /^\/admin\/login$/, title: 'Login Admin' },
  { pattern: /^\/admin\/dashboard$/, title: 'Dashboard' },
  { pattern: /^\/admin\/matches$/, title: 'Kelola Pertandingan' },
  { pattern: /^\/admin\/teams$/, title: 'Kelola Tim' },
  { pattern: /^\/admin\/websites$/, title: 'Kelola Website' },
  { pattern: /^\/admin\/partners$/, title: 'Kelola Partner' },
  { pattern: /^\/admin\/leaderboard$/, title: 'Kelola Leaderboard' },
  { pattern: /^\/admin\/winners$/, title: 'Kelola Pemenang' },
  { pattern: /^\/admin\/terms$/, title: 'Kelola Syarat & Ketentuan' },
  { pattern: /^\/admin\/settings$/, title: 'Pengaturan Website' },
  { pattern: /^\/admin\/predictions$/, title: 'Prediksi' },
  { pattern: /^\/admin\/tickets$/, title: 'Ticket Center' },
  { pattern: /^\/admin\/participants$/, title: 'Peserta' },
];

const resolveTitle = (pathname) => {
  for (const { pattern, title } of ROUTE_TITLES) {
    if (pattern.test(pathname)) return title;
  }
  return null;
};

export const PageTitleUpdater = () => {
  const { pathname } = useLocation();
  const { settings } = useSettings();

  useEffect(() => {
    const rawSiteName = settings?.website_name || 'EXTRA TIME';
    // Split on em/hyphen so long tag lines don't leak into the tab title.
    const siteName = rawSiteName.replace(/\s*[-—|]\s*.*$/, '').trim() || 'EXTRA TIME';
    const pageTitle = resolveTitle(pathname);
    document.title = pageTitle ? `${pageTitle} | ${siteName}` : siteName;
  }, [pathname, settings?.website_name]);

  return null;
};
